// extracted by mini-css-extract-plugin
export var container = "_ic-0";
export var content = "_ic-3";
export var customerTitle = "_ic-4";
export var empty = "_ic-5";
export var gray = "_ic-6";
export var header = "_ic-7";
export var info = "_ic-8";
export var loading = "_ic-2";
export var loadingCard = "_ic-9";
export var oneLine = "_ic-a";
export var personName = "_ic-e";
export var pillContainer = "_ic-b";
export var selected = "_ic-1";
export var text = "_ic-c";
export var twoLines = "_ic-d";
export var unread = "_ic-f";
export var unreadIndicator = "_ic-g";